export const GET_CUSTOMER_CODES_REQUEST = "GET_CUSTOMER_CODES_REQUEST";
export const GET_CUSTOMER_CODES_SUCCESS = "GET_CUSTOMER_CODES_SUCCESS";
export const GET_CUSTOMER_CODES_FAILURE = "GET_CUSTOMER_CODES_FAILURE";

export const GET_PERMISSIONS_REQUEST = "GET_PERMISSIONS_REQUEST";
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS";
export const GET_PERMISSIONS_FAILURE = "GET_PERMISSIONS_FAILURE";

export const GET_REFERENCES_REQUEST = "GET_REFERENCES_REQUEST";
export const GET_REFERENCES_SUCCESS = "GET_REFERENCES_SUCCESS";
export const GET_REFERENCES_FAILURE = "GET_REFERENCES_FAILURE";

export const GET_REFERENCE_NO_OPTIONS_REQUEST = "GET_REFERENCE_NO_OPTIONS_REQUEST";
export const GET_REFERENCE_NO_OPTIONS_SUCCESS = "GET_REFERENCE_NO_OPTIONS_SUCCESS";
export const GET_REFERENCE_NO_OPTIONS_FAILURE = "GET_REFERENCE_NO_OPTIONS_FAILURE";

export const GET_VENDORS_LIST_REQUEST = "GET_VENDORS_LIST_REQUEST";
export const GET_VENDORS_LIST_SUCCESS = "GET_VENDORS_LIST_SUCCESS";
export const GET_VENDORS_LIST_FAILURE = "GET_VENDORS_LIST_FAILURE";

export const GET_SERVICE_TYPE_LOOKUP_REQUEST =
  "GET_SERVICE_TYPE_LOOKUP_REQUEST";
export const GET_SERVICE_TYPE_LOOKUP_SUCCESS =
  "GET_SERVICE_TYPE_LOOKUP_SUCCESS";
export const GET_SERVICE_TYPE_LOOKUP_FAILURE =
  "GET_SERVICE_TYPE_LOOKUP_FAILURE";

export const RESET_MASTER_DATA_REDUCER = "RESET_MASTER_DATA_REDUCER";
